import React from 'react';

export default function EditorWrapper({ children, onSave, onCancel }) {
  return (
    <div className="cm-cell-editing" onClick={e => e.stopPropagation()}>
      {children}
    </div>
  );
}
